export default {"src":"/_next/static/media/invest_preview.88617108.webp","height":240,"width":240,"blurWidth":0,"blurHeight":0};